import { render, staticRenderFns } from "./goodsStatistics.vue?vue&type=template&id=08e11394&scoped=true"
import script from "./goodsStatistics.vue?vue&type=script&lang=js"
export * from "./goodsStatistics.vue?vue&type=script&lang=js"
import style0 from "./goodsStatistics.vue?vue&type=style&index=0&id=08e11394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e11394",
  null
  
)

export default component.exports